import { useTranslation } from 'react-i18next';

const Contacta = ({ config }) => {
    const { t } = useTranslation();


    return (
        <div className="mb-80">
            <h2 className="text-center h2">Contacta con nosotros</h2>
            <ul className="mb-6 o-list-features o-list-features_rounded">
                <li className="w-100 o-col-xs-mw3">
                    <span className="round">
                        <img src="https://pro-static.h10hotels.com/templates/H10/src/icons/mail.svg" />
                    </span>
                    <span >
                        <strong >
                            <a className="text-decoration-none" href={`mailto:${config.email_fiscal}`}>{config.email_fiscal}</a>
                        </strong>
                        <br />
                    </span>
                </li>
                <li className="w-100 o-col-xs-mw3">
                    <span className="round">
                        <img src="https://pro-static.h10hotels.com/templates/H10/src/icons/call_.svg" />
                    </span>
                    <span >
                        <strong >{t("Información y reservas")}</strong>
                        <br />
                        <a className="text-decoration-none" href={`tel: ${config.telefono_fiscal}`}> {config.telefono_fiscal}</a>
                    </span>
                </li>
                <li className="w-100 o-col-xs-mw3">
                    <span className="round">
                        <img src="https://pro-static.h10hotels.com/templates/H10/src/icons/ubicacion.svg" />
                    </span>
                    <span >
                        <strong>{config.poblacion_fiscal}</strong>
                        <br /> {config.direccion_fiscal}, {config.codigo_postal_fiscal}.{config.nif_fiscal}</span>
                </li>
            </ul>
        </div>
    );
};

export default Contacta;
